import React, { useState, useEffect, useRef, HtmlHTMLAttributes } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./style.css";
import logo from "../../../../redcliffe_logo.jpeg";
import nabllogo from "../../../../NABL Logo.png";
import mra from "../../../../mra.png";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Select, MenuItem, TextField } from '@material-ui/core';
import moment from "moment";
import { green } from "@mui/material/colors";
import { connect } from "react-redux";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import NpsRating from "../../NPS";


const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const Cma315Report: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState()
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);

    const [userInput, setUserInput] = useState("");

    const handleInputChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setUserInput(e.target.value);
    };
    //Report Data
    const [Cma315, setCma315] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setCma315(data);
    }, [reportListParameter])


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])

    //Booking Data
    const [Cma315Report, setCma315Report] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setCma315Report(data);
    }, [reportListParameter])

    useEffect(() => {
        setSample_Collected(Cma315Report[0]?.collection_date);
        setSample_Receivedtime(Cma315Report[0]?.pickup_time);
        setdesignation(Cma315Report[0]?.designation);
        setGender(Cma315Report[0]?.customer_gender);
        setSample_Received(Cma315Report[0]?.pickup_date);
        setName(Cma315Report[0]?.customer_name);
        setAge(Cma315Report[0]?.customer_age);
        setDob(Cma315Report[0]?.dob);
        setUuid(Cma315Report[0]?.uuid)

    }, [Cma315Report]);


    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);

        }
        else {

            setAge(Cma315Report[0]?.customer_age);
        }
    }, [dob]);


    //Lmp
    const [lmp, setLmp] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.lmp_date &&
            reportListParameter?.lmp_date.length > 0
        ) {
            reportListParameter?.lmp_date?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLmp(data);
    }, [reportListParameter]);

    const updateLmp = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...lmp]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLmp(storeData);
    }

    // Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }


    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }

    // Hospital Id
    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }


    //CLINICAL HISTORY 
    const [Cma315History, setCma315History] = useState<any>([]);
    useEffect(() => {
        const Cma315clincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_significance
            &&
            reportListParameter?.clinical_significance
                ?.length > 0
        ) {
            reportListParameter?.clinical_significance
                ?.map((list: any) => {
                    Cma315clincdata?.push({ ...list });
                });
        }
        setCma315History(Cma315clincdata);
    }, [reportListParameter]);

    const updateHistory = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...Cma315History]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setCma315History(storeData);
    }

    //CLINICAL INDICATIONS 
    const [Cma315ClinData, setCma315ClinData] = useState<any>([]);
    useEffect(() => {
        const Cma315clincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication &&
            reportListParameter?.clinical_indication?.length > 0

        ) {
            reportListParameter?.clinical_indication?.map((list: any) => {
                Cma315clincdata?.push({ ...list });
            });
        }
        setCma315ClinData(Cma315clincdata);
    }, [reportListParameter]);

    const updateClientIndication = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...Cma315ClinData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setCma315ClinData(storeData);
    }

    // METHOD
    const [Method, setMethod] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.methodology
            &&
            reportListParameter?.methodology
                .length > 0
        ) {
            reportListParameter?.methodology
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setMethod(data);
    }, [reportListParameter]);

    const updateMethod = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Method]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setMethod(storeData);
    }


    // Result 
    const [Cma315ResultRemark, setCma315ResultRemark] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks2 &&
            reportListParameter?.remarks2.length > 0
        ) {
            reportListParameter?.remarks2?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setCma315ResultRemark(data);
    }, [reportListParameter]);

    const updateResultRemark = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Cma315ResultRemark]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setCma315ResultRemark(storeData);
    }

    // VARIANTS TABLE
    let Data = [
        {
            id: 1,
            cnstate: "NA",
            type: "NA",
            chromosome: "NA",
            cytoband: "NA",
            size: "NA",
            omim: "NA",
            microarray: "NA",
            call: "NA",
        },
        {
            id: 2,
            cnstate: "NA",
            type: "NA",
            chromosome: "NA",
            cytoband: "NA",
            size: "NA",
            omim: "NA",
            microarray: "NA",
            call: "NA",
        },
        {
            id: 3,
            cnstate: "NA",
            type: "NA",
            chromosome: "NA",
            cytoband: "NA",
            size: "NA",
            omim: "NA",
            microarray: "NA",
            call: "NA",
        },
    ];

    const [VarientResult, setVarientResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            reportListParameter?.result_brca?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setVarientResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);
    const [isDefChromosome, setIsDefChromosome] = useState<boolean>(false);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];

        const isValidJSON = (str: string) => {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
            };
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            data = reportListParameter?.result_brca[0]?.parameter_value;
            if (data && isValidJSON(data)) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
            else {
                Data?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setTableData(storeData);
        let tempChromosomes: string[] = [];

        storeData.forEach((list: any) => {
            if (!["N", "A", "NA", ""].includes(list?.chromosome) && list?.chromosome) {
                if (tempChromosomes.length === 0 || tempChromosomes[tempChromosomes.length - 1] !== list?.chromosome) {
                    tempChromosomes.push(list?.chromosome);
                }
            }
        });

        const hasMultipleChromosomes = tempChromosomes.length > 1;
        setIsDefChromosome(hasMultipleChromosomes);
    }, [reportListParameter]);

    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "cnstate":
                newItem.cnstate = value;
                break;
            case "type":
                newItem.type = value;
                break;
            case "chromosome":
                newItem.chromosome = value;
                break;
            case "cytoband":
                newItem.cytoband = value;
                break;
            case "size":
                newItem.size = value;
                break;
            case "omim":
                newItem.omim = value;
                break;
            case "microarray":
                newItem.microarray = value;
                break;
            case "call":
                newItem.call = value;
                break;


        }
        storeData[index] = newItem;
        setTableData(storeData);


        let tempChromosomes: string[] = [];

        storeData.forEach((list: any) => {
            if (!["N", "A", "NA", ""].includes(list?.chromosome) && list?.chromosome) {
                if (tempChromosomes.length === 0 || tempChromosomes[tempChromosomes.length - 1] !== list?.chromosome) {
                    tempChromosomes.push(list?.chromosome);
                }
            }
        });

        const hasMultipleChromosomes = tempChromosomes.length > 1;
        setIsDefChromosome(hasMultipleChromosomes);



    };

    const [filePreviews, setFilePreviews] = useState<Array<string[]>>([]);

    const handleFileUpload = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };





    //graph 0
    const [Cma315graph, setCma315graph] = useState<any>([]);
    useEffect(() => {
        const bcrgraph: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image1 &&
            reportListParameter?.graph_image1?.length > 0
        ) {
            reportListParameter?.graph_image1?.map((list: any) => {
                bcrgraph?.push({ ...list });
            });
        }
        setCma315graph(bcrgraph);
    }, [reportListParameter]);

    const updateGraphData = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Cma315graph]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setCma315graph(storeData);
    }

    const [mccstatement, setmccstatement] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result1

            &&
            reportListParameter?.result1

                .length > 0
        ) {
            reportListParameter?.result1

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setmccstatement(data);
    }, [reportListParameter]);

    const updateMccstatement = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...mccstatement]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setmccstatement(storeData);
    }
    // Interpretation
    const [Cma315Interpretation, setCma315Interpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.interpretation &&
            reportListParameter?.interpretation.length > 0
        ) {
            reportListParameter?.interpretation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setCma315Interpretation(data);
    }, [reportListParameter]);

    const updateInterpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Cma315Interpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setCma315Interpretation(storeData);
    }


    //RECOMMMENDATION
    const [Cma315Recomendation, setCma315Recomendation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.recommendations &&
            reportListParameter?.recommendations.length > 0
        ) {
            reportListParameter?.recommendations?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setCma315Recomendation(data);
    }, [reportListParameter]);

    const updateRecommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Cma315Recomendation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setCma315Recomendation(storeData);
    }

    //DISCLAIMER
    const [Cma315Disclaimer, setCma315Disclaimer] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.disclaimer &&
            reportListParameter?.disclaimer.length > 0
        ) {
            reportListParameter?.disclaimer?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setCma315Disclaimer(data);
    }, [reportListParameter]);

    const updateDisclaimer = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Cma315Disclaimer]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setCma315Disclaimer(storeData);
    }

    // REPORTING AND LIMITATIONS
    const [Cma315Limitation, setCma315Limitation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.condition_for_reporting
            &&
            reportListParameter?.condition_for_reporting
                .length > 0
        ) {
            reportListParameter?.condition_for_reporting
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setCma315Limitation(data);
    }, [reportListParameter]);

    const updateLimitation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Cma315Limitation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setCma315Limitation(storeData);
    }


    //REFrence
    const [Cma315Refrence, setCma315Refrence] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.refrence_interval &&
            reportListParameter?.refrence_interval.length > 0
        ) {
            reportListParameter?.refrence_interval?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setCma315Refrence(data);
    }, [reportListParameter]);

    const updateRefrence = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Cma315Refrence]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setCma315Refrence(storeData);
    }

    //doctor list
    const [Cma315doctorList, setCma315doctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setCma315doctorList(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Cma315doctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setCma315doctorList(storeData);
    }

    //T13 Interpretations
    const [t13interpretation, sett13interpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T13_Interpretation
            &&
            reportListParameter?.T13_Interpretation
                .length > 0
        ) {
            reportListParameter?.T13_Interpretation
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        sett13interpretation(data);
    }, [reportListParameter]);

    const updateT13interpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t13interpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett13interpretation(storeData);
    }

    //T15 Interpretations
    const [t15interpretation, sett15interpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T15_Interpretation &&
            reportListParameter?.T15_Interpretation.length > 0
        ) {
            reportListParameter?.T15_Interpretation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett15interpretation(data);
    }, [reportListParameter]);

    const updateT15interpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t15interpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett15interpretation(storeData);
    }

    //T16 Interpretations
    const [t16interpretation, sett16interpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T16_Interpretation &&
            reportListParameter?.T16_Interpretation.length > 0
        ) {
            reportListParameter?.T16_Interpretation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett16interpretation(data);
    }, [reportListParameter]);

    const updateT16interpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t16interpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett16interpretation(storeData);
    }

    //T18 Interpretations
    const [t18interpretation, sett18interpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T18_Interpretation &&
            reportListParameter?.T18_Interpretation.length > 0
        ) {
            reportListParameter?.T18_Interpretation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett18interpretation(data);
    }, [reportListParameter]);

    const updateT18interpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t18interpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett18interpretation(storeData);
    }

    //T21 Interpretations
    const [t21interpretation, sett21interpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T21_Interpretation &&
            reportListParameter?.T21_Interpretation.length > 0
        ) {
            reportListParameter?.T21_Interpretation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett21interpretation(data);
    }, [reportListParameter]);

    const updateT21interpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t21interpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett21interpretation(storeData);
    }

    //T21 Interpretations
    const [t22interpretation, sett22interpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T22_Interpretation &&
            reportListParameter?.T22_Interpretation.length > 0
        ) {
            reportListParameter?.T22_Interpretation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett22interpretation(data);
    }, [reportListParameter]);

    const updateT22interpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t22interpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett22interpretation(storeData);
    }

    //T13 Reference
    const [t13reference, sett13reference] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T13_Reference &&
            reportListParameter?.T13_Reference.length > 0
        ) {
            reportListParameter?.T13_Reference?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett13reference(data);
    }, [reportListParameter]);

    const updateT13Reference = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t13reference]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett13reference(storeData);
    }

    //T15 Reference
    const [t15reference, sett15reference] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T15_Reference &&
            reportListParameter?.T15_Reference.length > 0
        ) {
            reportListParameter?.T15_Reference?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett15reference(data);
    }, [reportListParameter]);

    const updateT15Reference = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t15reference]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett15reference(storeData);
    }

    //T16 Reference
    const [t16reference, sett16reference] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T16_Reference &&
            reportListParameter?.T16_Reference.length > 0
        ) {
            reportListParameter?.T16_Reference?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett16reference(data);
    }, [reportListParameter]);

    const updateT16Reference = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t16reference]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett16reference(storeData);
    }


    //T18 Reference
    const [t18reference, sett18reference] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T18_Reference &&
            reportListParameter?.T18_Reference.length > 0
        ) {
            reportListParameter?.T18_Reference?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett18reference(data);
    }, [reportListParameter]);

    const updateT18Reference = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t18reference]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett18reference(storeData);
    }

    //T21 Reference
    const [t21reference, sett21reference] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T21_Reference &&
            reportListParameter?.T21_Reference.length > 0
        ) {
            reportListParameter?.T21_Reference?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett21reference(data);
    }, [reportListParameter]);

    const updateT21Reference = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t21reference]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett21reference(storeData);
    }

    //T22 Reference
    const [t22reference, sett22reference] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T22_Reference &&
            reportListParameter?.T22_Reference.length > 0
        ) {
            reportListParameter?.T22_Reference?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett22reference(data);
    }, [reportListParameter]);

    const updateT22Reference = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t22reference]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett22reference(storeData);
    }


    // interpritation option 
    // const [selectedOption, setSelectedOption] = useState("normal");

    // const [optionSelected, setOptionSelected] = useState(false);

    // const handleDropdownChange = (value: React.SetStateAction<string>) => {
    //     setSelectedOption(value);

    // };



    // // reference option
    // const [selectedOption1, setSelectedOption1] = useState("normal");

    // const [optionSelected1, setOptionSelected1] = useState(false);

    // const handleDropdownChange1 = (value: React.SetStateAction<string>) => {
    //     setSelectedOption1(value);

    // };


    // const [isTextPrinted, setTextPrinted] = useState(false);



    //T13 Recommendation
    const [t13recommendation, sett13recommendation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T13_Recommendation &&
            reportListParameter?.T13_Recommendation.length > 0
        ) {
            reportListParameter?.T13_Recommendation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett13recommendation(data);
    }, [reportListParameter]);

    const updateT13Recommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t13recommendation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett13recommendation(storeData);
    }

    //T15 Recommendation
    const [t15recommendation, sett15recommendation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T15_Recommendation &&
            reportListParameter?.T15_Recommendation.length > 0
        ) {
            reportListParameter?.T15_Recommendation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett15recommendation(data);
    }, [reportListParameter]);

    const updateT15Recommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t15recommendation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett15recommendation(storeData);
    }

    //T16 Recommendation
    const [t16recommendation, sett16recommendation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T16_Recommendation &&
            reportListParameter?.T16_Recommendation.length > 0
        ) {
            reportListParameter?.T16_Recommendation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett16recommendation(data);
    }, [reportListParameter]);

    const updateT16Recommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t16recommendation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett16recommendation(storeData);
    }


    //T18 Recommendation
    const [t18recommendation, sett18recommendation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T18_Recommendation &&
            reportListParameter?.T18_Recommendation.length > 0
        ) {
            reportListParameter?.T18_Recommendation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett18recommendation(data);
    }, [reportListParameter]);

    const updateT18Recommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t18recommendation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett18recommendation(storeData);
    }

    //T21 Recommendation
    const [t21recommendation, sett21recommendation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T21_Recommendation &&
            reportListParameter?.T21_Recommendation.length > 0
        ) {
            reportListParameter?.T21_Recommendation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett21recommendation(data);
    }, [reportListParameter]);

    const updateT21Recommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t21recommendation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett21recommendation(storeData);
    }

    //T22 Recommendation
    const [t22recommendation, sett22recommendation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.T22_Recommendation &&
            reportListParameter?.T22_Recommendation.length > 0
        ) {
            reportListParameter?.T22_Recommendation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sett22recommendation(data);
    }, [reportListParameter]);

    const updateT22Recommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...t22recommendation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sett22recommendation(storeData);
    }

    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }



    //Submit Data
    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (lmp.length > 0) {
            lmp?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Cma315Report.length > 0) {
            Cma315Report?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Cma315Refrence.length > 0) {
            Cma315Refrence?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Cma315.length > 0) {
            Cma315?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (Cma315ClinData.length > 0) {
            Cma315ClinData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Method.length > 0) {
            Method?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (Cma315Disclaimer.length > 0) {
            Cma315Disclaimer?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (Cma315ResultRemark.length > 0) {
            Cma315ResultRemark?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Cma315Limitation.length > 0) {
            Cma315Limitation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Cma315History.length > 0) {
            Cma315History?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (mccstatement.length > 0) {
            mccstatement?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (Cma315Interpretation.length > 0) {
            Cma315Interpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (Cma315graph.length > 0) {
            Cma315graph?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Cma315Recomendation.length > 0) {
            Cma315Recomendation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Cma315doctorList.length > 0) {
            Cma315doctorList?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t13interpretation.length > 0) {
            t13interpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t15interpretation.length > 0) {
            t15interpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t16interpretation.length > 0) {
            t16interpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t18interpretation.length > 0) {
            t18interpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t21interpretation.length > 0) {
            t21interpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t22interpretation.length > 0) {
            t22interpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t13reference.length > 0) {
            t13reference?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t15reference.length > 0) {
            t15reference?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (t16reference.length > 0) {
            t16reference?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t18reference.length > 0) {
            t18reference?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t21reference.length > 0) {
            t21reference?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t22reference.length > 0) {
            t22reference?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t13recommendation.length > 0) {
            t13recommendation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t15recommendation.length > 0) {
            t15recommendation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (t16recommendation.length > 0) {
            t16recommendation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t18recommendation.length > 0) {
            t18recommendation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t21recommendation.length > 0) {
            t21recommendation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (t22recommendation.length > 0) {
            t22recommendation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        const stringify = JSON.stringify(tableData);
        if (VarientResult.length > 0) {
            VarientResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        // const reportData = {
        //     template_id: secondP,
        //     booking_id: firstP,
        //     case_id: firstP,
        //     status: status,
        //     template_parameter: storeData,
        // };
        // const reportEditData = {
        //     template_id: secondP,
        //     booking_id: firstP,
        //     case_id: firstP,
        //     status: status,
        //     template_parameter: storeData,
        // };
        // if (thirdP === "add") {
        //     await createNewReport(reportData);
        //     navigator('/dashboard/la');
        // } else if (thirdP === "edit") {
        //     await updateReport(reportListParameter?.id, reportEditData);
        // }

        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            status: status,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }

    };

    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
    const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])

    const documentTitle = `${Cma315Report[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="Cma315-page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                                <div style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                    <h3>
                                        <img src={mra} alt="logo" style={{ width: "90px",marginTop:"5px" }} />
                                    </h3>
                                </div>
                                <div  style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                    <div style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                        <h3>
                                            <img src={nabllogo} alt="logo" style={{ width: "65px",marginTop:"5px" }} />
                                        </h3>
                                    </div>
                                    <div style={{ textAlign: "center", marginTop: "-8px" }}>
                                        <p style={{ fontSize: "16px", color: "#333", fontWeight: "bold",width:"70px" }}>MC-5280</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="Cma315-main-content3">.</div>
                    <div
                        style={{
                            fontSize: "35px",
                            // color: "#73016d",
                            textAlign: "center",
                            marginBottom: "20px",

                        }}
                    >
                        <span style={{ fontWeight: "bold", color: "#400354", }}>CMA-</span>
                        <span style={{ fontWeight: "bold", color: "#750b1e" }}>315K</span>

                    </div>
                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "18px", marginTop: "13px", }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="Cma315-marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {Cma315Report[0]?.pk
                                                ? Cma315Report[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>




                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>


                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Age
                                        </Grid>
                                        {dob === "" || dob === null ? (
                                            <Grid item xs={8.5}>
                                                :
                                                {/* {(Cma315Report[0]?.customer_name.includes('Af') ||
                                                    Cma315Report[0]?.customer_name.includes('AF') ||
                                                    Cma315Report[0]?.customer_name.includes('CVS') ||
                                                    Cma315Report[0]?.customer_name.includes('Cvs') ||
                                                    Cma315Report[0]?.customer_name.includes('POC') ||
                                                    Cma315Report[0]?.customer_name.includes('Poc') ||
                                                    Cma315Report[0]?.customer_name.includes('FETUS') ||
                                                    Cma315Report[0]?.customer_name.includes('Fetus') ||
                                                    Cma315Report[0]?.customer_name.includes('F/O'))
                                                    ? 'NA'
                                                    : <> <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                    </>
                                                } */}
                                                 <> <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                    </>
                                            </Grid>
                                        ) : (
                                            <Grid item xs={8.5}>
                                                :
                                                {/* {(Cma315Report[0]?.customer_name.includes('Af') ||
                                                    Cma315Report[0]?.customer_name.includes('AF') ||
                                                    Cma315Report[0]?.customer_name.includes('CVS') ||
                                                    Cma315Report[0]?.customer_name.includes('Cvs') ||
                                                    Cma315Report[0]?.customer_name.includes('POC') ||
                                                    Cma315Report[0]?.customer_name.includes('Poc') ||
                                                    Cma315Report[0]?.customer_name.includes('FETUS') ||
                                                    Cma315Report[0]?.customer_name.includes('Fetus') ||
                                                    Cma315Report[0]?.customer_name.includes('F/O'))
                                                    ? 'NA'
                                                    :
                                                    <span> {age} Y</span>

                                                } */}
                                                <span> {age} Y</span>
                                            </Grid>
                                        )
                                        }
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            GA/LMP Date
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :{lmp?.map((list: any, index: number) => {
                                                return (
                                                    // <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)} />
                                                    <input
                                                        style={{
                                                            border: "none",
                                                            width: "97%",
                                                            background: "none",
                                                            fontWeight: "bold",
                                                        }}
                                                        value={list?.parameter_value}
                                                        onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)}
                                                    />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>

                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : 
                                            {/* {(Cma315Report[0]?.customer_name.includes('Af') ||
                                                Cma315Report[0]?.customer_name.includes('AF') ||
                                                Cma315Report[0]?.customer_name.includes('CVS') ||
                                                Cma315Report[0]?.customer_name.includes('Cvs') ||
                                                Cma315Report[0]?.customer_name.includes('POC') ||
                                                Cma315Report[0]?.customer_name.includes('Poc') ||
                                                Cma315Report[0]?.customer_name.includes('FETUS') ||
                                                Cma315Report[0]?.customer_name.includes('Fetus') ||
                                                Cma315Report[0]?.customer_name.includes('F/O'))
                                                ? 'NA'
                                                : <input
                                                    className="input"
                                                    style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                    type="text"
                                                    value={Gender}
                                                    onChange={(e) => setGender(e.target.value)}
                                                />} */}
                                                 <input
                                                    className="input"
                                                    style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                    type="text"
                                                    value={Gender}
                                                    onChange={(e) => setGender(e.target.value)}
                                                />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {Cma315Report[0]?.center?.name && Cma315Report[0]?.center?.name.toUpperCase().includes("ARMC") ? (

                                        <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>
                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="tissue"> FFPE TISSUE BLOCK  </option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:mm:ss"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Paper>
                    <div style={{ width: "95%", marginLeft: "24px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Performed:-{Cma315Report[0]?.packages[0]?.name}</h6>
                    </div>

                    <div className="Cma315-br">.</div>
                    {/* clinical HISTORY  */}
                    <div className="Cma315-clinical__indi1368731catio" >
                        <span className="Cma315-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL HISTORY</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {Cma315History?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={4}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateHistory(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>

                    {/* clinical indication  */}
                    <div className="Cma315-clinical__indicatio" >
                        <span className="Cma315-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL INDICATION</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {Cma315ClinData?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={4}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>

                    <div className="Cma315-clinical__indicatio" >
                        <span className="Cma315-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>METHOD </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="contain" style={{ border: "none", width: "90%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}>

                        {(
                            Method?.map((list: any, index: number) => (
                                <div style={{ width: "100%", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={112}
                                            rows={3}
                                            style={{ border: "none", resize: "none" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateMethod(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            ))
                        )}


                    </div>
                    <div className="Cma315-br">.</div>
                    {/* results  */}
                    <div className="Cma315-clinical__indicatio" >
                        <span className="Cma315-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>RESULT</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="contain" style={{ border: "none", width: "90%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}>

                        {Cma315ResultRemark?.map((list: any, index: number) => {
                            const value = list?.parameter_value || "";
                            const isPathogenic = value.includes("Pathogenic");
                            const isBenign = value.includes("Likely pathogenic");
                            const color = isPathogenic || isBenign ? "red" : "black";
                            return (
                                <div style={{ width: "100%", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={112}
                                            rows={3}
                                            style={{ color: color, border: "none", resize: "none" }}
                                            value={value}
                                            onChange={(e) =>
                                                updateResultRemark(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}

                    </div>


                    {/* <div className="Cma315-main-content4">.</div> */}
                    <div className="Cma315-br">.</div>

                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around' }}>
                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>
                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>

                    <div className="Cma315-main-content2">.</div>
                    <div className="Cma315-main-content4">.</div>
                    {/* <div className="Cma315-br">.</div> */}

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{Cma315Report[0]?.designation}&nbsp;{Cma315Report[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{Cma315Report[0]?.pk}
                    </div>
                    <div className="Cma315-br">.</div>
                    <div className="Cma315-clinical__indicatio" >
                        <span className="Cma315-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>VARIANTS TABLE</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    <div style={{ width: "93%", border: "1px solid gray", marginLeft: "40px", height: "55px", }}>
                        <div style={{ display: "flex", background: "#e8eded", color: "  rgb(5, 57, 110)", fontWeight: "bolder", fontSize: "18px", height: "55px", textAlign: "center" }}>
                            <p style={{ width: "8%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>CN State</p>
                            <p style={{ width: "7%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Type</p>
                            <p style={{ width: "12%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Chromosome</p>
                            <p style={{ width: "9%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Cytoband Start</p>
                            <p style={{ width: "11%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>OMIM® Genes Count</p>
                            <p style={{ width: "12%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Size (kb)</p>
                            <p style={{ width: "25%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Microarray Nomenclature</p>
                            <p style={{ width: "8%", textAlign: "center", marginLeft: "8px" }}>CLASSIFICATION</p>

                        </div>
                    </div>
                    <div>
                        <div className="contain" style={{ border: "1px solid gray", width: "93%", marginLeft: '40px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    fontSize: "14px",
                                                    height: "50px",
                                                }}

                                            >


                                                <div
                                                    style={{ width: "8%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                            value={list?.cnstate}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "cnstate", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "7%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                            value={list?.type}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "type", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "12%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                            value={list?.chromosome}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "chromosome", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "9%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                            value={list?.cytoband}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "cytoband", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "11%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                            value={list?.omim}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "omim", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "12%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                            value={list?.size}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "size", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>

                                                <div
                                                    style={{ width: "25%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <textarea
                                                            cols={112}
                                                            rows={2}
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center", resize: "none" }}
                                                            value={list?.microarray}
                                                            onChange={(e) =>
                                                                updateRow(
                                                                    index,
                                                                    "microarray",
                                                                    e.target.value,
                                                                    list

                                                                )
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "16%", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                            value={list?.call}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "call", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>

                                            </div>

                                        </>
                                    );
                                })}
                        </div>
                    </div>

                    <div className="Cma315-br">.</div>
                    <div className="Cma315-clinical__indicatio" >
                        <span
                            className="Cma315-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            KARYOVIEW CNVs
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    {/* upload image  */}
                    <div style={{ display: "flex" }}>
                        <>

                            {Cma315graph.map((list: any, index: number) => {
                                return (
                                    <div
                                        key={index}
                                        style={{ width: "94%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                    >
                                        {/* Display base64-encoded image */}
                                        {
                                            thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'graph_image7' && list.parameter_value && list.parameter_value.startsWith('data:image/') && (
                                                <div>
                                                    <img
                                                        src={list.parameter_value}
                                                        alt={`Image ${index}`}
                                                        style={{ width: '100%', height: 'auto', maxHeight: "500pX" }}
                                                    />
                                                </div>
                                            )
                                        }
                                        {/* Display file previews */}
                                        {index === 0 && filePreviews[index] && (
                                            <div>
                                                {filePreviews[index].map((preview: string, previewIndex: number) => (
                                                    <img
                                                        key={previewIndex}
                                                        src={preview}
                                                        alt={`File Preview ${previewIndex + 1}`}
                                                        style={{ width: "100%", height: "auto", maxHeight: "500px" }}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                        {thirdP === "edit" ? "" :
                                            <input
                                                type="file"
                                                onChange={(e) => handleFileUpload(e.target.files, index, list)}
                                            />}
                                    </div>
                                );
                            })}
                        </>
                    </div>
                    <div className="Cma315-br">.</div>
                    <div className="Cma315-br">.</div>




                    {/* <div className="Cma315-main-content4">.</div> */}
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="Cma315-main-content2">.</div>
                    <div className="Cma315-main-content4">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{Cma315Report[0]?.designation}&nbsp;{Cma315Report[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{Cma315Report[0]?.pk}
                    </div>

                    <div className="Cma315-br">.</div>
                    <div className="Cma315-clinical__indicatio" >
                        <span
                            className="Cma315-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            INTERPRETATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    {isDefChromosome || tableData.every((list: any) => ["N", "A", "NA", ""].includes(list.chromosome)) ? <div>
                        {Cma315Interpretation.map((list: any, index: number) => {
                            return (
                                <div
                                    key={list?.id}
                                    style={{
                                        width: "45%",
                                        padding: 15,
                                        textAlign: "left",
                                        fontSize: "17px",
                                        marginLeft: "35px",
                                    }}
                                >
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={15}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateInterpretation(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div> : tableData?.length > 0 && (
                        <>
                            {tableData.some((list: any) => list?.chromosome === "13") && (
                                <div>
                                    {t13interpretation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={15}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT13interpretation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "15") && (
                                <div>
                                    {t15interpretation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={15}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT15interpretation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "16") && (
                                <div>
                                    {t16interpretation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={15}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT16interpretation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "18") && (
                                <div>
                                    {t18interpretation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={15}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT18interpretation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            {tableData.some((list: any) => list?.chromosome === "21") && (
                                <div>
                                    {t21interpretation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={15}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT21interpretation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "22") && (
                                <div>
                                    {t22interpretation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={15}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT22interpretation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}


                        </>
                    )}
                    <div className="Cma315-br">.</div>
                    <div className="Cma315-clinical__indicatio" >
                        <span
                            className="Cma315-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            MCC STATEMENT
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {mccstatement.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "90%", padding: 10, textAlign: "left", fontSize: "17px", marginRight: "20px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginTop: "5px" }}
                                            rows={3}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateMccstatement(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div className="Cma315-br">.</div>
                    <div className="Cma315-clinical__indicatio" >
                        <span
                            className="Cma315-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            RECOMMENDATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    {isDefChromosome || tableData.every((list: any) => ["N", "A", "NA", ""].includes(list.chromosome)) ? <div>
                        {Cma315Recomendation.map((list: any, index: number) => {
                            return (
                                <div
                                    key={list?.id}
                                    style={{
                                        width: "45%",
                                        padding: 15,
                                        textAlign: "left",
                                        fontSize: "17px",
                                        marginLeft: "35px",
                                    }}
                                >
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={5}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateRecommendation(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div> : tableData?.length > 0 && (
                        <>
                            {tableData.some((list: any) => list?.chromosome === "13") && (
                                <div>
                                    {t13recommendation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={5}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT13Recommendation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "15") && (
                                <div>
                                    {t15recommendation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={5}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT15Recommendation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "16") && (
                                <div>
                                    {t16recommendation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={5}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT16Recommendation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "18") && (
                                <div>
                                    {t18recommendation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={5}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT18Recommendation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            {tableData.some((list: any) => list?.chromosome === "21") && (
                                <div>
                                    {t21recommendation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={5}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT21Recommendation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "22") && (
                                <div>
                                    {t22recommendation.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={5}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT22Recommendation(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}


                        </>
                    )}
                    <div className="Cma315-br">.</div>


                    {/* <div className="Cma315-br">.</div> */}
                    {/* <div className="Cma315-main-content3">.</div> */}
                    {/* <div className="Cma315-main-content4">.</div>/ */}


                    {/* <div className="Cma315-br">.</div>
                <div className="Cma315-main-content3">.</div> */}
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={5}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="Cma315-br">.</div>

                    <div className="Cma315-main-content2">.</div>
                    <div className="Cma315-main-content4">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{Cma315Report[0]?.designation}&nbsp;{Cma315Report[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{Cma315Report[0]?.pk}
                    </div>

                    <div className="Cma315-br">.</div>
                    <div className="Cma315-clinical__indicatio" >
                        <span
                            className="Cma315-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            TECHNOLOGY
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        <div style={{ width: "93%", marginLeft: "50px", fontSize: "17px", wordBreak: "break-word", hyphens: "auto" }}>
                            <p>
                                Chromosomal Microarray Based Cytogenetic Analysis by Cytoscan 315K on Affymetrix (Thermo Fisher
                                Scientific) Platform. The CytoScanTM 315K Array enables the detection of high resolution copy
                                number across the genome as well as providing allelic imbalance information from single nucleotide
                                polymorphisms (SNPs). This high density array contains greater than 315,000 markers for copy
                                number and genotype-able SNPs which provide high resolution copy number, accurate breakpoint
                                estimation, copy-neutral loss of heterozygosity (LOH) detection, uniparental isodisomy (UPD), and
                                regions identical-by-descent. The SNPs on this array are from the public SNP database (dbSNP). They
                                were chosen to maximize genomic coverage, genotyping accuracy, and optimized to enable detection
                                of homozygosity. This microarray and associated software is designed by Affymetrix and used for the
                                purpose of identifying DNA copy number gains and losses associated with chromosomal imbalances.
                                DNA for the experiment is isolated from the provided sample using a commercial kit that works on
                                silica-membrane-based DNA purification. Genome version used is Genome Reference Consortium
                                Human Build 38 (GRCh38) – hg38. The following database are regularly used for interpretation calls-
                                Database of Genomic Variants (DGV),Curated variants from NCBI-dbVAR database (formerly defined
                                by International Standards for Cytogenomic Arrays -ISCA), Clinical Genome Resource (ClinGen),
                                OMIM, DECIPHER, CLINVAR, UCSC. ACMG reporting guidelines are followed in making variant calls.
                            </p>

                        </div>



                    </div>
                    <div className="Cma315-br">.</div>
                    <div style={{ width: "100%", fontSize: "17px", color: "rgb(28, 78, 128)", fontWeight: "bold", marginLeft: "40px" }}>
                        <p>Test results are interpreted based on the recommendations and guidelines of International Standard of Cytogenomics Arrays (ISCA) as
                            described below</p>
                    </div>
                    <div className="Cma315-br">.</div>

                    <div style={{ width: "93%", marginLeft: "40px", }}>
                        <table >
                            <tr style={{ border: "1px solid rgb(184, 168, 167)", }}>
                                <th style={{ color: "rgb(28, 78, 128)", borderRight: "1px solid rgb(184, 168, 167) ", backgroundColor: "#e8eded" }}> Copy Number Changes</th>
                                <td style={{ textAlign: "left", padding: "5px" }}>A change in a segment of DNA at least 1kb in size that differ in copy number compared to reference genome. This could be either increase (Gain) or decrease (Loss) in chromosome number. Copy Number Change </td>
                            </tr>
                            <tr style={{ border: "1px solid rgb(184, 168, 167)" }}>
                                <th style={{ color: "rgb(28, 78, 128)", borderRight: "1px solid rgb(184, 168, 167) ", backgroundColor: "#e8eded" }}>
                                    Pathogenic
                                </th>
                                <td style={{ textAlign: "left", padding: "5px" }}>
                                    This category includes CNVs, which overlaps with clearly established clinical significance. This usually means that a suspected disorder for which testing had been requested has been confirmed.</td>
                            </tr>
                            <tr style={{ border: "1px solid rgb(184, 168, 167)" }}>
                                <th style={{ color: "rgb(28, 78, 128)", borderRight: "1px solid rgb(184, 168, 167) ", backgroundColor: "#e8eded" }}>
                                    Likely Pathogenic
                                </th>
                                <td style={{ textAlign: "left", padding: "5px" }}>
                                    This category includes CNVs, that overlaps with a genomic region consistent with a syndrome containing OMIM morbid genes as well as deletions that overlap autosomal recessive genes (which may
                                    unmask a recessive allele associated with a syndrome/disorder).
                                </td>
                            </tr>
                            <tr style={{ border: "1px solid rgb(184, 168, 167)" }}>
                                <th style={{ color: "rgb(28, 78, 128)", borderRight: "1px solid rgb(184, 168, 167) ", backgroundColor: "#e8eded" }}>
                                    Variants of Unknown
                                    Significance (VOUS)
                                </th>
                                <td style={{ textAlign: "left", padding: "5px" }}>
                                    This category includes CNVs, within a region which is not associated with genetic syndromes or symptoms of disease, deletions that overlap autosomal recessive genes (which may unmask a recessive
                                    allele but is not associated with a syndrome/disorder), de novo CNVs with no OMIM genes or genes associated with diseases
                                </td>
                            </tr>
                            <tr style={{ border: "1px solid rgb(184, 168, 167)" }}>
                                <th style={{ color: "rgb(28, 78, 128)", borderRight: "1px solid rgb(184, 168, 167) ", backgroundColor: "#e8eded" }}>Likely Benign</th>
                                <td style={{ textAlign: "left", padding: "5px" }}>
                                    The CNVs overlaps with the genome listed as benign in ISCA or other database based on large patient samples. Heterozygous duplication with no known OMIM morbid genes.
                                </td>
                            </tr>
                            <tr style={{ border: "1px solid rgb(184, 168, 167)" }}>
                                <th style={{ color: "rgb(28, 78, 128)", borderRight: "1px solid rgb(184, 168, 167) ", backgroundColor: "#e8eded" }}>
                                    Benign
                                </th>
                                <td style={{ textAlign: "left", padding: "5px" }}>
                                    This category includes CNVs which are known not to be responsible for disease. Generally, no further action is warranted on such detections.
                                </td>
                            </tr>

                        </table>
                    </div>
                    <div className="Cma315-br">.</div>

                    <div className="Cma315-main-content4">.</div>
                    {/* <div className="Cma315-main-content4">.</div> */}
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="Cma315-main-content2">.</div>
                    <div className="Cma315-main-content4">.</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{Cma315Report[0]?.designation}&nbsp;{Cma315Report[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{Cma315Report[0]?.pk}
                    </div>
                    <div className="Cma315-br">.</div>
                    <div className="Cma315-clinical__indicatio" >
                        <span
                            className="Cma315-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            DISCLAIMER
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {Cma315Disclaimer.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={8}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDisclaimer(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>

                    <div className="Cma315-br">.</div>
                    <div className="Cma315-clinical__indicatio" >
                        <span
                            className="Cma315-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            REPORTING & LIMITATIONS
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "97%" }}>
                        {Cma315Limitation.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={12}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateLimitation(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div className="Cma315-br">.</div>
                    <div className="Cma315-br">.</div>
                    <div className="Cma315-main-content3">.</div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>



                    <div className="Cma315-main-content2">.</div>
                    <div className="Cma315-main-content4">.</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{Cma315Report[0]?.designation}&nbsp;{Cma315Report[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{Cma315Report[0]?.pk}
                    </div>
                    <br />
                    <div className="Cma315-clinical__indicatio" >
                        <span className="Cma315-clinical__subheadin" style={{ padding: "0px 10px 0px 45px", fontSize: "20px" }}>REFERENCE</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    {isDefChromosome || tableData.every((list: any) => ["N", "A", "NA", ""].includes(list.chromosome)) ? <div>
                        {Cma315Refrence.map((list: any, index: number) => {
                            return (
                                <div
                                    style={{
                                        width: "45%",
                                        padding: 15,
                                        textAlign: "left",
                                        fontSize: "17px",
                                        marginLeft: "35px",
                                    }}
                                >
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={22}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateRefrence(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div> : tableData?.length > 0 && (
                        <>
                            {tableData.some((list: any) => list?.chromosome === "13") && (
                                <div>
                                    {t13reference.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={22}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT13Reference(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "15") && (
                                <div>
                                    {t15reference.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={22}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT15Reference(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "16") && (
                                <div>
                                    {t16reference.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={22}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT16Reference(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "18") && (
                                <div>
                                    {t18reference.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={22}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT18Reference(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            {tableData.some((list: any) => list?.chromosome === "21") && (
                                <div>
                                    {t21reference.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={22}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT21Reference(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tableData.some((list: any) => list?.chromosome === "22") && (
                                <div>
                                    {t22reference.map((list: any, index: number) => {
                                        return (
                                            <div
                                                style={{
                                                    width: "45%",
                                                    padding: 15,
                                                    textAlign: "left",
                                                    fontSize: "17px",
                                                    marginLeft: "35px",
                                                }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none" }}
                                                        rows={22}
                                                        cols={112}
                                                        value={list?.parameter_value}
                                                        onChange={(e) =>
                                                            updateT22Reference(
                                                                list?.id,
                                                                e.target.value,
                                                                index,
                                                                "free_text",
                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                        </>
                    )}

                    <div className="Cma315-br">.</div>

                    <div className="Cma315-br">.</div>
                    <div className="Cma315-main-content3">.</div>
                    <div className="Cma315-main-content4">.</div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {Cma315doctorList && Cma315doctorList?.length > 0 && Cma315doctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    {/* patient details page 2 end */}

                    {/* footer section starting */}
                    <div className="Cma315-page-footer">
                        {/* footer area */}
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>genee@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="Cma315-box"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                                            {
                                                uuid && (
                                                    <div className="hide-section-rating">
                                                        <NpsRating bookingId={firstP} uuid={uuid} />
                                                    </div>
                                                )
                                            }
                </div>
            </div >
        </Grammarly >
    );
};
const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(Cma315Report);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}
